import { createFileRoute } from "@tanstack/react-router";
import StoredAssessmentResults from "@/features/onboarding/pages/stored-assessment-results/StoredAssessmentResults";

export const Route = createFileRoute("/$locale/$partner/_results/stored-assessment-results")({
	component: StoredAssessmentResults,
});
